module.exports = __webpack_public_path__ + "static/ff-landing-image-body-recipe-alexandr-dzyuba-EXE_dw4bP1M-unsplash.e69700ef.jpg";